// Icons
import { Coin, Plus } from "phosphor-react";

// Panels
import Information from "../Panels/Static/Information";
import List from "../Panels/Collections/List";
import DonutChart from "../Panels/Graph/DonutChart";
import LineChart from "../Panels/Graph/LineChart";

// Others
import React from "react";

const Revenue = () => {
  return (
    <section className="w-full h-full pl-0.5 pr-1 noDesktop:[&>*]:w-[95%] noDesktop:flex noDesktop:flex-col noDesktop:items-end">
      <section className="flex">
        <Coin size={27.5} className="text-brand-500 mr-2" weight="bold" />
        <h1 className="text-xl">Revenue</h1>
      </section>

      <main className="w-full h-full mt-3 grid grid-rows-5 grid-cols-4 gap-3 noDesktop:flex noDesktop:flex-col noDesktop:[&>*]:h-[300px]">
        {/* Row One */}
        <Information title={"Total Revenue"} rowSpan={1} colSpan={1} />
        <LineChart title={"Revenue Per Day"} colSpan={2} rowSpan={2} />
        <List title={"Revenue List"} colSpan={1} rowSpan={3} Icon={Plus} />

        {/* Row Two */}
        <DonutChart
          title={"Revenue Sources Comparison"}
          colSpan={1}
          rowSpan={2}
        />
        <Information title={"Total Revenue"} rowSpan={1} colSpan={1} />
        <Information title={"Total Revenue"} rowSpan={1} colSpan={1} />

        {/* Row Three */}
        <DonutChart title={"Revenue Categories"} colSpan={1} rowSpan={2} />
        <LineChart title={"Category Time Stamp"} colSpan={2} rowSpan={2} />
        <List
          title={"Revenue Categories"}
          colSpan={1}
          rowSpan={2}
          Icon={Plus}
        />
      </main>
    </section>
  );
};

export default Revenue;
